import SEO from "../../../../../src/components/Seo";
import * as React from 'react';
export default {
  SEO,
  React
};